import { render, staticRenderFns } from "./DiseaseMenu.vue?vue&type=template&id=5b8be8db"
import script from "./DiseaseMenu.vue?vue&type=script&lang=js"
export * from "./DiseaseMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports